import { extractCSSVars } from "src/utils/helpers";

import colors from "src/view/styles/exports/colors.module.scss";

export const COLOR = extractCSSVars<string>(colors, (a: string) => a) as Readonly<Constant.Color>;
